import { MessageFormatElement } from 'react-intl'
import { TranslationKey } from './translations'
import en from './translations/en'
import mn from './translations/mn'
import { Locale } from '@/context/LanguageContext'

const messages: Record<Locale, Record<TranslationKey, string> | Record<TranslationKey, MessageFormatElement[]>> = {
  en,
  mn
}

export default messages
